export const getAutocompleteClassNames = () => {
  return {
    optionsContainer:
      'absolute top-full w-full py-xs bg-white border border-status-selected border-t-0 rounded-b z-popup shadow overflow-auto max-h-52',
    option: 'flex gap-xs px-sm py-3xs text-sm transition-colors',
  };
};
